var _defs, _circle, _path, _polygon, _polygon2, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChambreRose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Calque 1",
    viewBox: "0 0 48.72 48.72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        stroke-width: 2px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #ff3ea5;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 1.4px;\n      }"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24.36,
    cy: 24.36,
    r: 23.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m39.06,27.02v-4.83c0-1.02-.83-1.85-1.85-1.85H10.76c-1.02,0-1.85.83-1.85,1.85v4.83h-1.99v3.51h34.13v-3.51h-1.99Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.92 30.52 8.92 34.25 11.25 34.25 16.42 30.52"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.06 30.52 39.06 34.25 36.86 34.25 31.01 30.52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m34.34 11.59c-2.77 0-5.49-0.77-7.85-2.21-1.54-0.94-3.48-0.94-5.02 0-2.36 1.45-5.08 2.21-7.85 2.21h-1.1c-1.17 0-2.11 0.94-2.11 2.11v6.65h27.14v-6.65c0-1.17-0.94-2.11-2.11-2.11h-1.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m21.78,20.34h-7.59c-.38-1.49-.38-3.05,0-4.54,2.68-.75,4.91-.75,7.58,0,.38,1.49.38,3.05,0,4.54Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.78,20.34h-7.59c-.38-1.49-.38-3.05,0-4.54,2.68-.75,4.91-.75,7.58,0,.38,1.49.38,3.05,0,4.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChambreRose);
export default __webpack_public_path__ + "static/media/Chambre_rose.2a83a74bf9b2c2cb4d7fa5818f140a48.svg";
export { ForwardRef as ReactComponent };